// @flow
import { TranslationAIActionTypes } from './constants';

const INIT_STATE = {
    translation: {},
    loading: false,
    error: false,
    formSubmited: false
}

type TranslationAIAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { translation?: {} | null, loading?: boolean, +value ?: boolean };

const TranslationAI = (state: State = INIT_STATE, action: TranslationAIAction): any => {
    // console.log(action);
    switch (action.type) {
        case TranslationAIActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TranslationAIActionTypes.ADD_TRANSLATION_AI: {
                    return {
                        ...state,
                        translation: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TranslationAIActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TranslationAIActionTypes.ADD_TRANSLATION_AI: {
                    return {
                        ...state,
                        translation: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case TranslationAIActionTypes.ADD_TRANSLATION_AI:
            return { ...state, error: false, loading: true };
        case TranslationAIActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                translation: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default TranslationAI;
